import { render, staticRenderFns } from "./OrdersHistory.vue?vue&type=template&id=d9a9b5e4&"
import script from "./OrdersHistory.vue?vue&type=script&lang=js&"
export * from "./OrdersHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHistory.vue?vue&type=style&index=0&id=d9a9b5e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports